import { Injectable } from '@angular/core';
import { FeatureToggle } from '@core/models/feature-toggle.model';
import { Tenant } from '@core/models/tenant.model';
import { environment } from '@environment/environment';
import { map, Observable, shareReplay } from 'rxjs';
import { AuthService } from '../auth-service/auth-service.service';

@Injectable()
export class FeatureToggleService {
  private cachedConfig$: Observable<FeatureToggle>;

  constructor(private authService: AuthService) {
    // Initialize the cached config
    this.cachedConfig$ = this.authService.getUserInfo().pipe(
      map((user) => {
        if (user === undefined || user === null) {
          return new FeatureToggle();
        }
        const newTenant = user.tenant;
        if (newTenant === undefined) {
          return new FeatureToggle();
        }
        let ft = new FeatureToggle();
        ft = this.patchPropertiesInFt(ft, newTenant);
        return ft;
      }),
      shareReplay(1),
    );
  }

  convertBoolean(myBool: boolean | undefined) {
    if (myBool === undefined) return false;
    return myBool;
  }

  validProperty(prop: any) {
    return prop !== undefined && prop !== null;
  }

  tenantComplete(tenant: Tenant): boolean {
    return (
      this.validProperty(tenant?.enable_ai) &&
      this.validProperty(tenant?.enable_barcode)
    );
  }

  patchPropertiesInFt(ft: FeatureToggle, tenant: Tenant): FeatureToggle {
    ft.enableAi = this.convertBoolean(tenant.enable_ai) && environment.enableAi;
    ft.enableBarcode =
      this.convertBoolean(tenant.enable_barcode) && environment.enableBarcode;
    ft.enableDiscussion =
      this.convertBoolean(tenant.enable_discussion) &&
      environment.enableDiscussion;
    ft.enableReport =
      this.convertBoolean(tenant.enable_report) && environment.enableReport;
    ft.enableProntuary =
      this.convertBoolean(tenant.enable_prontuary) &&
      environment.enableProntuary;
    ft.enableRegisterCase =
      this.convertBoolean(tenant.enable_register_case) &&
      environment.enableRegisterCase;
    ft.enableImageDatabase =
      this.convertBoolean(tenant.enable_image_database) &&
      environment.enableImageDatabase;
    ft.enableKi67 =
      this.convertBoolean(tenant.enable_ki67) && environment.enableKi67;
    ft.enableMonitorCase = this.convertBoolean(tenant.enable_monitor_case);

    if (tenant.use_external_folder && tenant.url_external) {
      ft.viewerUrlExternal = tenant.url_external;
    }
    return ft;
  }

  getConfig(): Observable<FeatureToggle> {
    return this.cachedConfig$;
  }
}
